import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem('dkr-token'));
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyToken = async () => {
            if (token) {
                try {
                    await axios.get(`${API}/auth/verify`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    setIsAuthenticated(true);
                } catch (error) {
                    localStorage.removeItem('dkr-token');
                    setToken(null);
                    setIsAuthenticated(false);
                }
            }
            setLoading(false);
        };
        verifyToken();
    }, [token]);

    const login = async (password) => {
        try {
            const response = await axios.post(`${API}/auth/login`, { password });
            const { access_token } = response.data;
            localStorage.setItem('dkr-token', access_token);
            setToken(access_token);
            setIsAuthenticated(true);
            return { success: true };
        } catch (error) {
            return { success: false, error: error.response?.data?.detail || 'Login failed' };
        }
    };

    const logout = () => {
        localStorage.removeItem('dkr-token');
        setToken(null);
        setIsAuthenticated(false);
    };

    const getAuthHeaders = () => ({
        headers: { Authorization: `Bearer ${token}` }
    });

    return (
        <AuthContext.Provider value={{ 
            token, 
            isAuthenticated, 
            loading, 
            login, 
            logout, 
            getAuthHeaders 
        }}>
            {children}
        </AuthContext.Provider>
    );
};
